import { FC } from 'react';
import { ProductionWorkflowTaskTWithIssues } from 'pages/production-workflow/controllers/production-workflow-additional-tasks.controller';
import FinishedAdditionalTaskItem from 'modules/manage-failed-tasks-modal/components/finished-additional-task-item/finished-additional-task-item';
import { Stack } from '@mui/material';
import s from '../finished-additional-task-item/finished-additional-task-item.module.scss';

type Props = {
  highlightName?: string;
  isProcessingGuard: boolean;
  taskInfo: ProductionWorkflowTaskTWithIssues;
};

const NestedFinishedAdditionalTaskItem: FC<Props> = ({ taskInfo, highlightName, isProcessingGuard }) => {
  return (
    <Stack paddingLeft="29px" className={s.left_line}>
      <FinishedAdditionalTaskItem taskInfo={taskInfo} isProcessingGuard={isProcessingGuard} highlightName={highlightName} />
    </Stack>
  );
};

export default NestedFinishedAdditionalTaskItem;
